module.exports = __webpack_public_path__ + "static/img/icon tj ocr.8eed8b4b.svg";